<template>
  <div>
    <b-card title="Ad Account Info">
      
      <b-row class="mt-1">
        <b-col cols="4">
          <v-select
            label="title"            
            :options="adaccountList"
            :clearable="false"
            v-model="selectedAdaccount"
            class="adaccount-select"
            placeholder="Select Ad Account"
          >
          </v-select>
        </b-col>
      </b-row>

      <b-row class="float-right">
        <feather-icon
          v-if="hasUpdatePermission('ad-accounts')"
          class="mr-1 cursor-pointer"
          icon="Edit2Icon"
          size="16"
          v-b-modal.update-ad-account-modal
          fill
        />
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4">
          <h5>Title</h5>
        </b-col>
        <b-col cols="8">{{ adAccount.title }}</b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="4">
          <h5>ID</h5>
        </b-col>
        <b-col cols="8">{{ adAccount.id }}</b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="4">
          <h5>Description</h5>
        </b-col>
        <b-col cols="8">{{ adAccount.description }}</b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4">
          <h5>Timezone</h5>
        </b-col>
        <b-col cols="8">{{ adAccount.timezone }}</b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="4">
          <h5>Currency</h5>
        </b-col>
        <b-col cols="8">{{ adAccount.currency }}</b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4">
          <h5>Created At</h5>
        </b-col>
        <b-col cols="8">
          {{
            formatDate(adAccount.createdAt, {
              month: "short",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
            })
          }}
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="4">
          <h5>Last Updated At</h5>
        </b-col>
        <b-col cols="8">
          {{
            formatDate(adAccount.updatedAt, {
              month: "short",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
            })
          }}
        </b-col>
      </b-row>
    </b-card>

    <update-ad-account-modal
      v-if="adAccount.id"
      :refreshData="setAdAccounts"
      :adAccount="adAccount"
    />

  </div>
</template>

<script>
import { BCard, BRow, BCol } from "bootstrap-vue";
import UpdateAdAccountModal from "@/views/settings/modal/UpdateAdAccountModal";

import AdaccountService from "@/services/ad-account.service";
import { formatDate } from "@core/utils/filter";
import vSelect from "vue-select";

export default {
  name: "AdAccountInfo",
  components: {
    BCard,
    BRow,
    BCol,
    UpdateAdAccountModal,
    vSelect,
  },
  data() {
    return {
      adAccount: {},
      adaccountList: [],
      selectedAdaccount: "",
    };
  },
  watch: {
    selectedAdaccount() {
      if(this.selectedAdaccount.id == "0000"){
        this.openCreateAdAccountModal(null, null);
      }else if(this.selectedAdaccount.id == undefined){
        
      }else{
        this.$store.dispatch('callMutation', { newSelectedAdAccount: this.selectedAdaccount.id })
        this.adAccount = this.selectedAdaccount;
        this.$root.$emit("refresh-adaccountinfo", this.adAccount);
      }
    },
  },
  methods: {
    /*
    async loadAdAccount() {
      const response = await AdaccountService.get();
      if (response && response.data.success) {
        this.adAccount = response.data.data;
      }
    },
    */
    async setAdAccounts() {
      const adaccounts = await AdaccountService.list();
      if (adaccounts.data.success) {
        this.adaccountList = adaccounts.data.data;
        let add = {
          "createdAt": "",
          "currency":"",
          "description":"",
          "id":"0000",
          "timezone":"",
          "title":"+ Add Ad Account",
          "updatedAt":"",
          "userId":"",
          "workPlaceId":""
        }
        this.adaccountList.push(add);
        
        if (adaccounts.data.data.length > 0){
          if (this.$store.getters.getSelectedAdAccount == '9999'){
            this.selectedAdaccount = this.adaccountList[0]
            this.$store.dispatch('callMutation', { newSelectedAdAccount: this.adaccountList[0].id })
          } else {
            const adaccount = await AdaccountService.getOne(this.$store.getters.getSelectedAdAccount);
            if (adaccount.data.success) {
              this.selectedAdaccount = adaccount.data.data;
            }
          }
        }
      }
    },
    openCreateAdAccountModal(id, mode) {
      this.createAdAccountModalKey = Math.floor(Math.random() * 100);
      this.editingId = id ? id : null;
      this.editingMode = mode ? mode : null;
      this.$nextTick(() => {
        this.$bvModal.show("create-ad-account-modal");
      });
    },
  },
  setup() {
    return {
      formatDate,
    };
  },
  created() {
    /* this.loadAdAccount(); */
    this.setAdAccounts();
  },
  mounted() {
    this.$root.$on("reload-adAccount-setting", () => {
      if(this.$store.getters.getSelectedAdAccount == '0000'){
        this.selectedAdaccount = "";
      }else{
        this.setAdAccounts();
      }
    });
  },
};
</script>

<style lang="scss">

.adaccount-select {
  font-size: large;

  .vs__dropdown-toggle {
    height: 80px;
  }

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

</style>
